const design = {
  // Wrapper
  wrapper: 'fixed right-0 top-0 h-screen z-40 hidden md:flex flex-col transition-all duration-300 ease-out',
  wrapperOpen: 'w-[60px]',
  wrapperClosed: 'w-0',

  // Toggle button — open state
  toggleButton: [
    'absolute -left-4 top-1/2 -translate-y-1/2 z-50',
    'w-8 h-8 rounded-full',
    'bg-white/90 backdrop-blur-sm',
    'border border-violet-200',
    'shadow-lg shadow-violet-500/10',
    'flex items-center justify-center cursor-pointer',
    'hover:bg-violet-50 hover:border-violet-300 hover:shadow-violet-500/20',
    'active:scale-90',
    'transition-all duration-200',
  ].join(' '),

  // Toggle button — closed state
  toggleButtonClosed: [
    'fixed right-0 top-1/2 -translate-y-1/2 z-50',
    'w-7 h-10 rounded-l-xl',
    'bg-pink-500/90 backdrop-blur-sm',
    'shadow-lg shadow-violet-500/30',
    'flex items-center justify-center cursor-pointer',
    'hover:bg-[#6d28d9] hover:w-9',
    'active:scale-95',
    'transition-all duration-200',
  ].join(' '),

  // Sidebar container — soft gradient
  sidebar: [
    'flex-1 flex flex-col',
    'bg-gradient-to-b from-[#fafafa] via-[#f5f5f5] to-[#f0f0f0]',
    'border-l border-gray-200/60',
    'shadow-[-2px_0_16px_rgba(0,0,0,0.04)]',
  ].join(' '),

  // Top accent line
  topAccent: 'h-[2.5px] bg-gradient-to-r from-violet-400 via-fuchsia-400 to-violet-400 shrink-0 rounded-b-full',

  // Avatar list area
  avatarList: 'flex-1 flex flex-col items-center gap-3 py-4 px-[9px] overflow-y-auto scrollbar-none',

  // Avatar wrapper
  avatarWrapper: [
    'relative cursor-pointer group flex-shrink-0',
    'rounded-xl',
    'transition-all duration-200 ease-out',
    'hover:scale-105',
    'active:scale-95',
  ].join(' '),

  // Avatar
  avatar: [
    'w-9 h-9 rounded-xl',
    'ring-1 ring-gray-200/80',
    'group-hover:ring-gray-300',
    'transition-all duration-200',
  ].join(' '),

  avatarFallback: [
    'rounded-xl',
    'bg-gray-200 text-gray-600',
    'text-[11px] font-semibold',
  ].join(' '),

  // Online indicator
  onlineIndicator: [
    'absolute -bottom-0.5 -right-0.5',
    'w-2.5 h-2.5 rounded-full',
    'bg-emerald-400',
    'border-2 border-[#f5f5f5]',
  ].join(' '),

  // Group indicator
  groupIndicator: [
    'absolute -top-0.5 -right-0.5',
    'w-4 h-4 rounded-md',
    'bg-white border border-gray-200',
    'flex items-center justify-center',
  ].join(' '),

  // Unread badge
  unreadBadge: [
    'absolute -top-1 -left-1',
    'min-w-[16px] h-[16px]',
    'flex items-center justify-center',
    'rounded-full px-1',
    'bg-[#7C3AED]',
    'text-[9px] font-bold text-white leading-none',
    'border-[1.5px] border-[#f5f5f5]',
  ].join(' '),

  // Tooltip
  tooltipContent: [
    'bg-[#1e1230] text-white text-xs font-medium',
    'px-3 py-2 rounded-xl',
    'shadow-xl shadow-violet-900/20',
    'border border-violet-500/15',
    'max-w-[180px] truncate',
  ].join(' '),
};

export default design;
